import ProductionVolumeApiResponse from "./production-volume-api-response.interface";

export default function isProductionVolumeApiResponse(
  arg: unknown
): arg is ProductionVolumeApiResponse {
  if (!(arg instanceof Object)) {
    return false;
  }

  const requiredKeys = [
    "todayCount",
    "weekCount",
    "prevWeekCount",
    "monthCount",
    "prevMonthCount",
  ];
  const tempArg = arg as Record<string, number>;

  for (const key of requiredKeys) {
    if (typeof tempArg[key] !== "number") {
      return false;
    }
  }

  return true;
}
